import "primereact/resources/primereact.min.css";

// import "primereact/resources/themes/lara-light-indigo/theme.css";
// import "primereact/resources/themes/lara-dark-indigo/theme.css";

import "animate.css";
import "bootstrap/dist/css/bootstrap.min.css";

import AppRoutes from "@routes/AppRoutes/AppRoutes";
import NotificationContainer from "react-notifications/lib/NotificationContainer";
import { SileoToaster } from "@components/general/SileoNotificaciones/SileoNotificaciones";
import React from "react";
// import { PrimeReactProvider, PrimeReactContext } from "primereact/api";
import UserProvider from "@context/User/UserProvider";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { PrimeReactProvider } from "primereact/api";
import { useTranslation } from "react-i18next";

const PlataformaClickPlus = () => {

	const stripePromiseLive = loadStripe("pk_live_51IE0gOFjRsT0gjxgx2Phi43JYhjKNMrsWrrUMo5Fp4lew8xWwGZtxUUscs1XPG3QtflOi8KQnlm7c4Wd9njeXUrR00qKYiy86I")
	const stripePromiseTest = loadStripe("pk_test_51IE0gOFjRsT0gjxg9MtRKLzHSYaYxKJHiJiryN4OqfytvSexyDFBUvuf2MZfL4A3qecujZ4Os14GAlyjLD570jII00KYH97ErX")
	
	const value = {
        appendTo: 'self',
    };

	const {i18n} = useTranslation();
	const currentLanguage = i18n.language;

	return (
		// {/* UserProvider - UserProvider para useContext(UserContext) */}
		<Elements stripe={stripePromiseLive} options={{locale: currentLanguage}} >
			<UserProvider>
				{/* ProSidebarProvider - Despliega el sidebar */}
					{/* Rutas de la aplicación */}
					<PrimeReactProvider>
						<AppRoutes />
					</PrimeReactProvider>

					{/* Notificaciones que no cierran SweetAlert */}
					<NotificationContainer />

					{/* Prueba: notificaciones con Sileo */}
					{/* <SileoToaster /> */}
			</UserProvider>
		</Elements>
	);
};

export default PlataformaClickPlus;
